import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=ff2245b6"
import script from "./Pie.vue?vue&type=script&lang=js"
export * from "./Pie.vue?vue&type=script&lang=js"
import style0 from "./Pie.vue?vue&type=style&index=0&id=ff2245b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports